import { render, staticRenderFns } from "./BaseLanguageSelect.vue?vue&type=template&id=3b029adc&"
import script from "./BaseLanguageSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseLanguageSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports